import styled, { rem } from '@nobia/zeus-components/lib/styled'

export const Heading1 = styled.h1`
  margin: 0;
  color: ${(p) => p.theme.typography.heading1.color};
  font-family: ${(p) => p.theme.typography.heading1.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading1.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.heading1.fontSize &&
    rem(p.theme.typography.heading1.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.heading1.lineHeight &&
    rem(p.theme.typography.heading1.lineHeight)};
  text-align: ${(p) => p.theme.typography.heading1.textAlign};
  text-transform: ${(p) => p.theme.typography.heading1.textTransform};

  ${(p) =>
    p.theme.typography.heading1.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.heading1.md.fontSize &&
      rem(p.theme.typography.heading1.md.fontSize)
    };
    line-height: ${
      p.theme.typography.heading1.md.lineHeight &&
      rem(p.theme.typography.heading1.md.lineHeight)
    };
  `}
`

export const Heading2 = styled.h2`
  margin: 0;
  color: ${(p) => p.theme.typography.heading2.color};
  font-family: ${(p) => p.theme.typography.heading2.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading2.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.heading2.fontSize &&
    rem(p.theme.typography.heading2.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.heading2.lineHeight &&
    rem(p.theme.typography.heading2.lineHeight)};
  text-align: ${(p) => p.theme.typography.heading2.textAlign};

  ${(p) =>
    p.theme.typography.heading2.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.heading2.md.fontSize &&
      rem(p.theme.typography.heading2.md.fontSize)
    };
    line-height: ${
      p.theme.typography.heading2.md.lineHeight &&
      rem(p.theme.typography.heading2.md.lineHeight)
    };
  `}
`

export const Heading3 = styled.h3`
  margin: 0;
  color: ${(p) => p.theme.typography.heading3.color};
  font-family: ${(p) => p.theme.typography.heading3.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading3.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.heading3.fontSize &&
    rem(p.theme.typography.heading3.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.heading3.lineHeight &&
    rem(p.theme.typography.heading3.lineHeight)};
  text-align: ${(p) => p.theme.typography.heading3.textAlign};

  ${(p) =>
    p.theme.typography.heading3.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.heading3.md.fontSize &&
      rem(p.theme.typography.heading3.md.fontSize)
    };
    line-height: ${
      p.theme.typography.heading3.md.lineHeight &&
      rem(p.theme.typography.heading3.md.lineHeight)
    };
  `}
`

export const Heading4 = styled.h4`
  margin: 0;
  color: ${(p) => p.theme.typography.heading4.color};
  font-family: ${(p) => p.theme.typography.heading4.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading4.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.heading4.fontSize &&
    rem(p.theme.typography.heading4.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.heading4.lineHeight &&
    rem(p.theme.typography.heading4.lineHeight)};
  text-align: ${(p) => p.theme.typography.heading4.textAlign};

  ${(p) =>
    p.theme.typography.heading4.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.heading4.md.fontSize &&
      rem(p.theme.typography.heading4.md.fontSize)
    };
    line-height: ${
      p.theme.typography.heading4.md.lineHeight &&
      rem(p.theme.typography.heading4.md.lineHeight)
    };
  `}
`

export const Heading5 = styled.h5`
  margin: 0;
  color: ${(p) => p.theme.typography.heading5.color};
  font-family: ${(p) => p.theme.typography.heading5.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading5.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.heading5.fontSize &&
    rem(p.theme.typography.heading5.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.heading5.lineHeight &&
    rem(p.theme.typography.heading5.lineHeight)};
  text-align: ${(p) => p.theme.typography.heading5.textAlign};

  ${(p) =>
    p.theme.typography.heading5.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.heading5.md.fontSize &&
      rem(p.theme.typography.heading5.md.fontSize)
    };
    line-height: ${
      p.theme.typography.heading5.md.lineHeight &&
      rem(p.theme.typography.heading5.md.lineHeight)
    };
  `}
`

export const Heading6 = styled.h6`
  margin: 0;
  color: ${(p) => p.theme.typography.heading6.color};
  font-family: ${(p) => p.theme.typography.heading6.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading6.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.heading6.fontSize &&
    rem(p.theme.typography.heading6.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.heading6.lineHeight &&
    rem(p.theme.typography.heading6.lineHeight)};
  text-align: ${(p) => p.theme.typography.heading6.textAlign};

  ${(p) =>
    p.theme.typography.heading6.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.heading6.md.fontSize &&
      rem(p.theme.typography.heading6.md.fontSize)
    };
    line-height: ${
      p.theme.typography.heading6.md.lineHeight &&
      rem(p.theme.typography.heading6.md.lineHeight)
    };
  `}
`

export const Preamble = styled.p`
  margin: 0;
  color: ${(p) => p.theme.typography.preamble.color};
  font-family: ${(p) => p.theme.typography.preamble.fontFamily};
  font-weight: ${(p) => p.theme.typography.preamble.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.preamble.fontSize &&
    rem(p.theme.typography.preamble.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.preamble.lineHeight &&
    rem(p.theme.typography.preamble.lineHeight)};
  text-align: ${(p) => p.theme.typography.preamble.textAlign};

  ${(p) =>
    p.theme.typography.preamble.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.preamble.md.fontSize &&
      rem(p.theme.typography.preamble.md.fontSize)
    };
    line-height: ${
      p.theme.typography.preamble.md.lineHeight &&
      rem(p.theme.typography.preamble.md.lineHeight)
    };
  `}
`

export const PreambleB = styled.p`
  margin: 0;
  color: ${(p) => p.theme.typography.preambleB.color};
  font-family: ${(p) => p.theme.typography.preambleB.fontFamily};
  font-weight: ${(p) => p.theme.typography.preambleB.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.preambleB.fontSize &&
    rem(p.theme.typography.preambleB.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.preambleB.lineHeight &&
    rem(p.theme.typography.preambleB.lineHeight)};
  text-align: ${(p) => p.theme.typography.preambleB.textAlign};

  ${(p) =>
    p.theme.typography.preambleB.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.preambleB.md.fontSize &&
      rem(p.theme.typography.preambleB.md.fontSize)
    };
    line-height: ${
      p.theme.typography.preambleB.md.lineHeight &&
      rem(p.theme.typography.preambleB.md.lineHeight)
    };
  `}
`

export const ParagraphLead = styled.p`
  margin: 0;
  color: ${(p) => p.theme.typography.paragraphLead.color};
  font-family: ${(p) => p.theme.typography.paragraphLead.fontFamily};
  font-weight: ${(p) => p.theme.typography.paragraphLead.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.paragraphLead.fontSize &&
    rem(p.theme.typography.paragraphLead.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.paragraphLead.lineHeight &&
    rem(p.theme.typography.paragraphLead.lineHeight)};
  text-align: ${(p) => p.theme.typography.paragraphLead.textAlign};

  ${(p) =>
    p.theme.typography.paragraphLead.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.paragraphLead.md.fontSize &&
      rem(p.theme.typography.paragraphLead.md.fontSize)
    };
    line-height: ${
      p.theme.typography.paragraphLead.md.lineHeight &&
      rem(p.theme.typography.paragraphLead.md.lineHeight)
    };
  `}
`

export const Paragraph = styled.p`
  margin: 0;
  color: ${(p) => p.theme.typography.paragraph.color};
  font-family: ${(p) => p.theme.typography.paragraph.fontFamily};
  font-weight: ${(p) => p.theme.typography.paragraph.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.paragraph.fontSize &&
    rem(p.theme.typography.paragraph.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.paragraph.lineHeight &&
    rem(p.theme.typography.paragraph.lineHeight)};
  text-align: ${(p) => p.theme.typography.paragraph.textAlign};

  ${(p) =>
    p.theme.typography.paragraph.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.paragraph.md.fontSize &&
      rem(p.theme.typography.paragraph.md.fontSize)
    };
    line-height: ${
      p.theme.typography.paragraph.md.lineHeight &&
      rem(p.theme.typography.paragraph.md.lineHeight)
    };
  `}
`

export const ParagraphSmall = styled.p`
  margin: 0;
  color: ${(p) => p.theme.typography.paragraphSmall.color};
  font-family: ${(p) => p.theme.typography.paragraphSmall.fontFamily};
  font-weight: ${(p) => p.theme.typography.paragraphSmall.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.paragraphSmall.fontSize &&
    rem(p.theme.typography.paragraphSmall.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.paragraphSmall.lineHeight &&
    rem(p.theme.typography.paragraphSmall.lineHeight)};
  text-align: ${(p) => p.theme.typography.paragraphSmall.textAlign};

  ${(p) =>
    p.theme.typography.paragraphSmall.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.paragraphSmall.md.fontSize &&
      rem(p.theme.typography.paragraphSmall.md.fontSize)
    };
    line-height: ${
      p.theme.typography.paragraphSmall.md.lineHeight &&
      rem(p.theme.typography.paragraphSmall.md.lineHeight)
    };
  `}
`

export const ParagraphByline = styled.p`
  margin: 0;
  color: ${(p) => p.theme.typography.paragraphByline.color};
  font-family: ${(p) => p.theme.typography.paragraphByline.fontFamily};
  font-weight: ${(p) => p.theme.typography.paragraphByline.fontWeight};
  font-size: ${(p) =>
    p.theme.typography.paragraphByline.fontSize &&
    rem(p.theme.typography.paragraphByline.fontSize)};
  line-height: ${(p) =>
    p.theme.typography.paragraphByline.lineHeight &&
    rem(p.theme.typography.paragraphByline.lineHeight)};
  text-align: ${(p) => p.theme.typography.paragraphByline.textAlign};

  ${(p) =>
    p.theme.typography.paragraphByline.md &&
    p.theme.media.min.md`
    font-size: ${
      p.theme.typography.paragraphByline.md.fontSize &&
      rem(p.theme.typography.paragraphByline.md.fontSize)
    };
    line-height: ${
      p.theme.typography.paragraphByline.md.lineHeight &&
      rem(p.theme.typography.paragraphByline.md.lineHeight)
    };
  `}
`
